import React from 'react';

export const LazyPaymentPage = React.lazy(() =>
  import('./PaymentPage').then((module) => ({
    default: module.PaymentPage,
  }))
);
